import React from "react";
import styled from "styled-components";
import { Modal, Input } from "@arco-design/web-react";
import { isBlank } from "../utils/validators";

// MUI -> Arco. Dialog(+Title/Content/Actions) -> Modal (visible/onOk/onCancel/
// title; Cancel/Save become okText/cancelText). MUI TextFields -> Arco Inputs
// with the label rendered above each field. Arco Input onChange passes the
// value, not an event. makeStyles -> styled-components; theme.spacing(1) = 8px.

const FieldLabel = styled.div`
  font-size: 12px;
  color: var(--color-text-3);
  margin-bottom: 4px;
`;

const Field = styled.div`
  margin-top: 8px;
`;

export default function ContactListAddEditDialog({ open, onSave, onClose, listName, setListName, listDescription, setListDescription, listId }) {

  const handleClose = () => {
    onClose && onClose();
  };

  const isValid = !isBlank(listName);

  const handleSave = () => {
    if (!isValid) {
      return;
    }
    onSave && onSave();
    handleClose();
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSave();
    }

    return false;
  }


  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      onOk={handleSave}
      title={`${listId != "" ? "Edit" : "Add"} List`}
      okText="Save"
      cancelText="Cancel"
      okButtonProps={{ disabled: !isValid }}
    >
      <Field>
        <FieldLabel>Name</FieldLabel>
        <Input
          autoFocus
          id="name"
          value={listName}
          onChange={(v) => {
            setListName(v);
          }}
        />
      </Field>

      <Field>
        <FieldLabel>Description</FieldLabel>
        <Input
          id="description"
          value={listDescription}
          onChange={(v) => {
            setListDescription(v);
          }}
          onKeyDownCapture={handleKeyPress}
        />
      </Field>
    </Modal>
  );
}
